import Button from '@/components/@base/button';
import Props from '@/components/app/product/components/@shared/comments-header/add-comment-button/type';

import { pageLevelLocalization } from '@/constant/localization';

import AddIcon from '~/images/icons/add';

const { product: productLocalization } = pageLevelLocalization;

export default function AddCommentButton({ onAddCommentClick, ...props }: Props) {
  return (
    <Button
      Icon={
        <AddIcon
          width={15}
          height={15}
          fill='fill-[#81CF33] group-hover:fill-[#FFFFFF]'
          className='h-3 w-3 fill-current text-[#81CF33] transition-all duration-300 group-hover:fill-[#FFFFFF] md:h-[15px] md:w-[15px]'
        />
      }
      onClick={onAddCommentClick}
      className='group h-12 bg-[#F5FBED] px-[13px] py-2.5 text-[13px] font-bold text-[#81CF33] transition-all hover:bg-[#81CF33] hover:text-[#FFFFFF]'
      {...props}
    >
      {productLocalization.addComment}
    </Button>
  );
}
